import { CsField, CsInfoRow, CsSection } from '@/components/Cs/CsSection'
import { csFieldClass } from '@/components/Cs/csFormStyles'
import type { CsAccountDetail } from '@/services/csService'

type Props = {
  account: CsAccountDetail
  onSave: (payload: Record<string, unknown>) => Promise<void>
}

export function CsAccountRelacionamento({ account, onSave }: Props) {
  return (
    <CsSection title='Relacionamento'>
      <CsField label='Principal dor do cliente'>
        <textarea
          className={csFieldClass}
          rows={2}
          defaultValue={account.dorPrincipal ?? ''}
          onBlur={(e) => void onSave({ dorPrincipal: e.target.value || null })}
        />
      </CsField>
      <CsField label='Próxima ação'>
        <textarea
          className={csFieldClass}
          rows={2}
          defaultValue={account.proximaAcao ?? ''}
          onBlur={(e) => void onSave({ proximaAcao: e.target.value || null })}
        />
      </CsField>
      <CsField label='Análises do relacionamento'>
        <textarea
          className={csFieldClass}
          rows={3}
          defaultValue={account.analiseRelacionamento ?? ''}
          onBlur={(e) => void onSave({ analiseRelacionamento: e.target.value || null })}
        />
      </CsField>
      <CsField label='Observações'>
        <textarea
          className={csFieldClass}
          rows={3}
          defaultValue={account.observacoes ?? ''}
          onBlur={(e) => void onSave({ observacoes: e.target.value || null })}
        />
      </CsField>
      <CsInfoRow
        label='Última interação'
        value={
          account.ultimaInteracaoEm
            ? new Date(account.ultimaInteracaoEm).toLocaleString('pt-BR')
            : account.interacoes[0]
              ? new Date(account.interacoes[0].data).toLocaleString('pt-BR')
              : null
        }
      />
    </CsSection>
  )
}
